import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Offline, Online } from 'react-detect-offline';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, CssBaseline, useMediaQuery } from '@mui/material';

// project imports
import { CurrencyProvider } from 'context/Currency';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Sidebar from './Sidebar';
import Customization from '../Customization';
import navigation from 'menu-items';
import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';
import SnackAlert from 'views/utilities/SnackAlert';
import { ApiUrl } from 'utils/Constants';
import Social from 'views/contact/social';

// assets
import { IconChevronRight } from '@tabler/icons-react';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        minHeight: '100vh',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            //marginRight: -(drawerWidth - 20),
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px 20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px 20px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginRight: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginRight: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: '10px'
        }
    })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));

    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };

    const polling = {
        enabled: true,
        url: `${ApiUrl}/api/online`,
        timeout: 3000,
        interval: 5000
    };

    useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    return (
        <Box sx={{ display: 'flex', background: theme.palette.background.light, justifyContent: 'center' }}>
            <CssBaseline />

            {/* drawer
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
            */}

            {/* main content */}
            <Main theme={theme}>
                {/*open={leftDrawerOpened}*/}
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title leftAlign />
                <CurrencyProvider>
                    <Outlet />
                </CurrencyProvider>
                {/*
                <Online polling={polling}>
                    <CurrencyProvider>
                        <Outlet />
                    </CurrencyProvider>
                </Online>
                <Offline polling={polling}>
                    <SnackAlert message="عـدم برقــراری ارتبـاط با ســرور!" type="error" hideDuration={999999999} />
                    <Social />
                </Offline>
                */}
            </Main>
            {/*
            <Customization />
             */}
        </Box>
    );
};

export default MainLayout;
